import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./contexts/userContext"; // Ensure this path is correct
import { CartProvider } from "./contexts/cartContext";
import { UserExchangeProvider } from "./contexts/userExchangeProgramContext";
import { RefreshProvider } from "./contexts/refreshLogin";
import { RefreshPriceProvider } from "./contexts/refreshPrice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import 'owl.carousel/dist/assets/owl.carousel.min.css';
// import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import $ from "jquery"; // This will ensure jQuery is available globally
import { ApiProvider } from "./shared/api";
import NavigationWrapper from "./components/NavigationWrapper";
import Navigation from "./navigation";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from './redux/store'

import 'bootstrap/dist/css/bootstrap.min.css';
import { PersistGate } from "redux-persist/integration/react";
import CityPopup from "./components/common/cityPopup";
import { ToastContainer } from "react-toastify";
import { LoginModal } from "./components/common/LoginModal";
import { initFacebookPixel } from "./shared/utils/faceboolPixel";
import { HelmetProvider } from "react-helmet-async";
import SeoCanonical from "./components/SeoCanonical";
import ChatWidget from "./components/chatWidget/ChatWidget";


// Make sure it's available globally for other scripts, like Owl Carousel

const rootElement = document.getElementById("root");
const gtmId = process.env.REACT_APP_GTM_ID;
const clarityId = process.env.REACT_APP_CLARITY_ID;
const showgtm = process.env.REACT_APP_SHOW_GTM;
const facebookPixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID;
const fbShow = process.env.REACT_APP_SHOW_FACEBOOK;


// ⚠️ If GTM is ALSO loading Facebook Pixel, remove this block
if (showgtm === "yes" && fbShow === "yes" && facebookPixelId) {
  initFacebookPixel(facebookPixelId);
}




if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <>
      <HelmetProvider>
        <BrowserRouter>
          <SeoCanonical />
          <RefreshPriceProvider>
            <RefreshProvider>
              <UserExchangeProvider>
                <UserProvider>
                  <CartProvider>
                    <Provider store={store}>
                      <PersistGate loading={null} persistor={persistor}>
                        <ApiProvider>
                          <Navigation />
                          <CityPopup />
                          <LoginModal />
                          <ChatWidget />
                        </ApiProvider>
                      </PersistGate>
                    </Provider>
                  </CartProvider>
                </UserProvider>
              </UserExchangeProvider>
            </RefreshProvider>
          </RefreshPriceProvider>
        </BrowserRouter>
        <ToastContainer />
      </HelmetProvider>
    </>


  );
} else {
  //console.error('Root element not found');
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();


// Inject Google Tag Manager (GTM) script
// if (showgtm === "yes") {
//   if (fbShow === "yes") {
//     if (facebookPixelId) {


//       // Inject the Facebook Pixel base code
//       (function (f: any, b: Document, p: string, i: string) {
//         f.fbq =
//           f.fbq ||
//           function () {
//             (f.fbq.q = f.fbq.q || []).push(arguments);
//           };
//         f.fbq("init", i); // Replace `i` with your Pixel ID
//         f.fbq("track", "PageView");

//         const t = b.createElement(p) as HTMLScriptElement;
//         const s = b.getElementsByTagName(p)[0];
//         t.async = true;
//         t.src = `https://connect.facebook.net/en_US/fbevents.js`;

//         if (s && s.parentNode) {
//           s.parentNode.insertBefore(t, s);
//         } else {
//           b.head.appendChild(t);
//         }
//       })(window, document, "script", facebookPixelId);
//       // For tracking events such as a "Purchase"
//     }
//   }
// } else {
//   //   
// }


// ✅ Service Worker registration (Web Push) — put it at the bottom, outside React
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        scope: "/",
      });

      console.log("✅ Service Worker registered:", registration.scope);

      // Optional: log lifecycle state
      if (registration.installing) {
        console.log("SW state: installing");
      } else if (registration.waiting) {
        console.log("SW state: waiting");
      } else if (registration.active) {
        console.log("SW state: active");
      }
    } catch (error) {
      console.error("❌ Service Worker registration failed:", error);
    }
  });
}